import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useCountUp } from './overviewTheme'

const StatTile = ({
  icon: Icon,
  label,
  value,
  hint,
  accent = '#1E7F88',
  url,
}) => {
  const displayValue = useCountUp(value ?? 0)

  return (
    <Paper
      component={motion.div}
      whileHover={{ y: -3 }}
      transition={{ type: 'spring', stiffness: 400, damping: 28 }}
      variant="outlined"
      sx={{
        p: 2,
        // height: '100%',
        position: 'relative',
        overflow: 'hidden',
        textDecoration: 'none',
        display: 'block',
        '&:hover': { boxShadow: '0 8px 20px rgba(15, 23, 42, 0.10)' },
      }}
      {...(url ? { component: motion(Link), to: url } : {})}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          backgroundColor: accent,
        }}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Stack gap={0.25}>
          <Typography variant="smallGrey">{label}</Typography>
          <Typography
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: '1.9rem',
              lineHeight: 1.2,
              color: 'text.primary',
            }}
          >
            {displayValue}
          </Typography>
        </Stack>
        {Icon && (
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: `${accent}18`,
              color: accent,
              flexShrink: 0,
            }}
          >
            <Icon fontSize="small" />
          </Box>
        )}
      </Stack>
      {hint && (
        <Typography variant="smallGrey" sx={{ fontSize: '0.72rem' }}>
          {hint}
        </Typography>
      )}
    </Paper>
  )
}

export default StatTile
